import { AutoComplete } from 'antd';
import useFuzzySearchHooks from '../../api/pages/fuzzySearchInputApi';
import _ from 'lodash';
const FuzzySearchInput: React.FC<{
    id?: string;
    maxLength?: number;
    placeholder?: string;
    value?: string;
    onChange: (newValue: string) => void;
}> = props => {
    const { data, setValue, setData, fetchData } = useFuzzySearchHooks();
    const options = data.map((item: string) => ({ value: item }));

    // 搜索补全项时候调用后端接口
    const handleSearch = (newValue: string) => {
        if (newValue) {
            fetchData('/platform/paddleorg/companySuggest', { entName: newValue, pageSize: 10 });
            setValue(newValue);
            props.onChange(newValue);
        } else {
            setData([]);
        }
    };

    // 选中时调用
    const handleSelect = (newValue: string) => {
        setValue(newValue);
        props.onChange(newValue);
        /* 其他处理逻辑 */
    };

    return (
        <AutoComplete
            // value={value}
            placeholder={props.placeholder}
            onSelect={handleSelect}
            onSearch={_.debounce(handleSearch, 200)}
            // onChange={handleChange}
            options={options}
        ></AutoComplete>
    );
};
export default FuzzySearchInput;
